import billingOptionSelected from './billing-option-selected.template.html';
import billingOptionTtem from './billing-option-item.template.html';

/* @ngInject */
export const templates = function ($templateCache) {
	$templateCache.put('billing-option-selected', billingOptionSelected);
	$templateCache.put('billing-option-item', billingOptionTtem);
};
